import { createReducer, Action, on } from '@ngrx/store';

import { TopicListActions } from './topic-list.actions';
import { TopicListState } from './topic-list.state';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';
import { AppActions } from '../app/app.actions';
import { TopicActions } from '../topic/topic.actions';

export const initialState: TopicListState = {
  loading: false,
  collapsedTopics: {},
  sort: { active: 'name', direction: 'asc' },
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(
      AppActions.LoadInitData,
      (state): TopicListState => ({ ...state, loading: true, error: undefined })
    ),
    on(
      TopicListActions.LoadTopicsSuccess,
      (state, action): TopicListState => ({
        ...state,
        topics: action.list,
        showInMenuIds: action.showInMenuIds || action.list.map((t) => t.id),
        orderedTopicIds: action.orderedTopicIds,
      })
    ),
    on(
      TopicListActions.DeleteTopicSuccess,
      (state, action): TopicListState => ({
        ...state,
        topics: state.topics.filter((t) => t.id !== action.id),
      })
    ),
    on(
      TopicListActions.SaveTopicDetailsSuccess,
      (state, action): TopicListState => ({
        ...state,
        topics: state.topics?.map((t) => (t.id !== action.topic.id ? t : action.topic)),
      })
    ),
    on(
      TopicListActions.CreateTopic,
      (state, action): TopicListState => ({ ...state, loading: true })
    ),
    on(
      TopicListActions.CreateTopicSuccess,
      TopicListActions.CloneModelSuccess,
      (state, action): TopicListState => ({
        ...state,
        topics: [...state.topics, action.topic],
        loading: false,
      })
    ),
    on(
      TopicListActions.ReorderTopics,
      (state, action): TopicListState => ({ ...state, orderedTopicIds: action.orderedTopicIds })
    ),
    on(
      TopicListActions.TopicsMetaUpdateSuccess,
      (state, action): TopicListState => ({
        ...state,
        showInMenuIds: action.showInMenuIds,
        orderedTopicIds: action.orderedTopicIds,
      })
    ),
    on(
      TopicListActions.SetCollapsedTopics,
      (state, action): TopicListState => ({
        ...state,
        collapsedTopics: action.collapsedTopics,
      })
    ),
    on(
      TopicActions.SaveTopicSuccess,
      (state, action): TopicListState => ({
        ...state,
        topics: state.topics?.map((topic) => (topic.id === action.topic.id ? action.topic : topic)),
      })
    ),
    on(
      AppActions.LoadInitDataSuccess,
      (state, action): TopicListState => ({
        ...state,
        loading: false,
        orderedTopicIds: action.data.assetSettings?.orderedTopicIds,
        showInMenuIds: action.data.assetSettings?.showInMenuIds,
      })
    ),
    on(
      TopicListActions.Search,
      (state, action): TopicListState => ({
        ...state,
        search: action.search,
      })
    ),
    on(
      TopicListActions.Filter,
      (state, action): TopicListState => ({
        ...state,
        filter: action.filter,
      })
    ),

    on(
      TopicListActions.Sort,
      (state, action): TopicListState => ({
        ...state,
        sort: action.sort,
      })
    )
  )
);

export function reducer(state: TopicListState | undefined, action: Action) {
  return featureReducer(state, action);
}
